import { render, staticRenderFns } from "./BaseTextSwitch.vue?vue&type=template&id=28748743&scoped=true"
import script from "./BaseTextSwitch.vue?vue&type=script&lang=js"
export * from "./BaseTextSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28748743",
  null
  
)

export default component.exports